import Phaser from 'phaser';

const spriteUrls = import.meta.glob('../assets/sprites/**/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

function collectFramesBySubstring(substring: string): string[] {
  return Object.entries(spriteUrls)
    .filter(([path]) => path.includes(substring))
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([, url]) => url);
}

export type SpriteFrameSet = { prefix: string; urls: string[] };

export function heroFrameSet(heroId: string, kind: 'idle' | 'attack'): SpriteFrameSet {
  return {
    prefix: `hero_${heroId}_${kind}`,
    urls: collectFramesBySubstring(`heroes/${heroId}/${kind}_`),
  };
}

export function enemyFrameSet(
  enemyId: string,
  kind: 'idle' | 'hit' | 'big_attack',
): SpriteFrameSet {
  return {
    prefix: `enemy_${enemyId}_${kind}`,
    urls: collectFramesBySubstring(`enemies/${enemyId}/${kind}_`),
  };
}

export function frameKey(prefix: string, index: number): string {
  return `${prefix}_${index}`;
}

export function preloadFrameSet(scene: Phaser.Scene, set: SpriteFrameSet) {
  set.urls.forEach((url, i) => {
    scene.load.image(frameKey(set.prefix, i), url);
  });
}

export function createAnimFromFrameSet(
  scene: Phaser.Scene,
  animKey: string,
  set: SpriteFrameSet,
  opts: { frameRate?: number; repeat?: number } = {},
) {
  if (set.urls.length === 0) return false;
  if (scene.anims.exists(animKey)) return true;
  scene.anims.create({
    key: animKey,
    frames: Array.from({ length: set.urls.length }, (_, i) => ({
      key: frameKey(set.prefix, i),
    })),
    frameRate: opts.frameRate ?? 6,
    repeat: opts.repeat ?? -1,
  });
  return true;
}
